import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { User } from '../types'
import { clearQueryCache } from '../lib/queryClient'

interface SupplierState {
  isSupplierAuthenticated: boolean
  supplierUser: User | null
  supplierToken: string | null

  setSupplierAuth: (user: User, token: string) => void
  clearSupplierAuth: () => void
}

export const useSupplierStore = create<SupplierState>()(
  persist(
    (set) => ({
      isSupplierAuthenticated: false,
      supplierUser: null,
      supplierToken: null,

      setSupplierAuth: (user, token) => set({
        isSupplierAuthenticated: true,
        supplierUser: user,
        supplierToken: token
      }),

      clearSupplierAuth: () => {
        set({
          isSupplierAuthenticated: false,
          supplierUser: null,
          supplierToken: null
        })
        // THE THIRD SESSION, and it needs the same backstop as the other two.
        // The partner portal's keys - ['supplier-profile'],
        // ['supplier-products'], ['supplier-qualification'],
        // ['supplier-service-requests'] - carry one partner's own profile,
        // catalogue, tier applications and inspection bookings under no
        // identity at all, so on a shared machine the next partner to sign in
        // would get one paint of the previous partner's business. Those keys
        // are not scoped per partner (only the CUSTOMER keys are, see
        // lib/queryKeys.ts); this clear is what covers them today.
        clearQueryCache()
      }
    }),
    {
      name: 'broxel-supplier-storage',
      partialize: (state) => ({
        isSupplierAuthenticated: state.isSupplierAuthenticated,
        supplierUser: state.supplierUser,
        supplierToken: state.supplierToken
      })
    }
  )
)
